import { useTranslation } from 'react-i18next';

import ControlledNumericField from '../../../../../shared/ControlledFields/ControlledNumericField';
import ReferenceDateSection from './ReferenceDateSection';

const CostOrgSection = () => {
  const { t } = useTranslation('common');

  return (
    <>
      <ReferenceDateSection />
      <ControlledNumericField
        label={t('orgLevel')}
        name="org_level"
        step={1}
        minValue={1}
        maxValue={10}
      />
    </>
  );
};

export default CostOrgSection;
